import type { PricingHistory } from "@warrenio/api-spec/spec.oats.gen";

export const pricingHistoryExample: PricingHistory = {
    "1970-01": {
        EUR: {
            DEFAULT: [
                {
                    resource_type: "CPU",
                    resource_prices: [
                        {
                            price_per_unit: 0.00721,
                            num_cpus_from: 1,
                            description: "Virtual Machine 1-2 CPUs",
                        },
                        {
                            price_per_unit: 0.00967,
                            num_cpus_from: 3,
                            description: "Virtual Machine 3+ CPUs",
                        },
                    ],
                },
                {
                    resource_type: "RAM",
                    resource_prices: [
                        {
                            gigabytes_from: 0.5,
                            price_per_unit: 0.00845,
                            description: "Virtual Machine 0.5-2 GiB RAM",
                        },
                        {
                            gigabytes_from: 3,
                            price_per_unit: 0.00487,
                            description: "Virtual Machine 3+ GiB RAM",
                        },
                    ],
                },
                {
                    resource_type: "BLOCK_STORAGE",
                    resource_prices: [
                        {
                            gigabytes_from: 1,
                            price_per_unit: 0.0002,
                            description: "Virtual Machine disk 1-80 GiB",
                        },
                        {
                            gigabytes_from: 81,
                            price_per_unit: 0.0003,
                            description: "Virtual Machine disk 81+ GiB",
                        },
                    ],
                },
                {
                    resource_type: "BLOCK_STORAGE_BACKUP",
                    resource_prices: [
                        {
                            gigabytes_from: 1,
                            price_per_unit: 0.0002,
                            description: "Backup of disk 1-80 GiB",
                        },
                        {
                            gigabytes_from: 81,
                            price_per_unit: 0.0003,
                            description: "Backup of disk 81+ GiB",
                        },
                    ],
                },
                {
                    resource_type: "BLOCK_STORAGE_SNAPSHOT",
                    resource_prices: [
                        {
                            price_per_unit: 0.0002,
                            gigabytes_from: 1,
                            description: "Snapshot of disk 1-80 GiB",
                        },
                        {
                            price_per_unit: 0.0003,
                            gigabytes_from: 81,
                            description: "Snapshot of disk 81+ GiB",
                        },
                    ],
                },
                {
                    resource_type: "WINDOWS_LICENSE",
                    resource_prices: [
                        {
                            price_per_unit: 0.005479452054794521,
                            description: "Windows license (per CPU)",
                        },
                    ],
                },
                {
                    resource_type: "OBJECT_STORAGE",
                    resource_prices: [
                        {
                            price_per_unit: 0.00214,
                            description: "Object storage",
                            price_per_unit_month: 1.5622,
                        },
                    ],
                },
                {
                    resource_type: "UNASSIGNED_FLOATING_IP",
                    resource_prices: [
                        {
                            price_per_unit: 0.00234,
                            description: "Unassigned floating IP",
                        },
                    ],
                },
            ],
        },
    },
    "2023-11": {
        EUR: {
            DEFAULT: [
                {
                    resource_type: "CPU",
                    resource_prices: [
                        {
                            price_per_unit: 0.007224,
                            num_cpus_from: 0,
                            description: "Virtual Machine less than 3 CPUs",
                        },
                        {
                            price_per_unit: 0.00956,
                            num_cpus_from: 3,
                            description: "Virtual Machine 3+ CPUs",
                        },
                    ],
                },
                {
                    resource_type: "RAM",
                    resource_prices: [
                        {
                            price_per_unit: 0.00845,
                            gigabytes_from: 0,
                            description: "Virtual Machine GiB RAM",
                        },
                    ],
                },
                {
                    resource_type: "BLOCK_STORAGE",
                    resource_prices: [
                        {
                            price_per_unit: 0.000234,
                            gigabytes_from: 1,
                            description: "Virtual Machine disk 1-80 GiB",
                        },
                        {
                            price_per_unit: 0.00065,
                            gigabytes_from: 81,
                            description: "Virtual Machine disk 81+ GiB",
                        },
                    ],
                },
                {
                    resource_type: "BLOCK_STORAGE_BACKUP",
                    resource_prices: [
                        {
                            gigabytes_from: 1,
                            price_per_unit: 0.0002,
                            description: "Backup of disk 1-80 GiB",
                        },
                        {
                            gigabytes_from: 81,
                            price_per_unit: 0.0003,
                            description: "Backup of disk 81+ GiB",
                        },
                    ],
                },
                {
                    resource_type: "BLOCK_STORAGE_SNAPSHOT",
                    resource_prices: [
                        {
                            gigabytes_from: 1,
                            price_per_unit: 0.0002,
                            description: "Snapshot of disk 1-80 GiB",
                        },
                        {
                            gigabytes_from: 81,
                            price_per_unit: 0.0003,
                            description: "Snapshot of disk 81+ GiB",
                        },
                    ],
                },
                {
                    resource_type: "WINDOWS_LICENSE",
                    resource_prices: [
                        {
                            price_per_unit: 0.00748,
                            description: "Windows license (per CPU)",
                        },
                    ],
                },
                {
                    resource_type: "OBJECT_STORAGE",
                    resource_prices: [
                        {
                            price_per_unit: 0.00814,
                            description: "Object storage",
                        },
                    ],
                },
                {
                    resource_type: "UNASSIGNED_FLOATING_IP",
                    resource_prices: [
                        {
                            price_per_unit: 0.00111,
                            description: "Unassigned floating IP",
                        },
                    ],
                },
                {
                    resource_type: "ASSIGNED_FLOATING_IP",
                    resource_prices: [],
                },
                {
                    resource_type: "LOAD_BALANCER",
                    resource_prices: [
                        {
                            price_per_unit: 0.003,
                            description: "Load balancer",
                        },
                    ],
                },
            ],
            "host_pool:00000000-0000-0000-0000-000167bb0a39": [
                {
                    resource_type: "CPU",
                    resource_prices: [
                        {
                            price_per_unit: 0.00721,
                            num_cpus_from: 0,
                            description: "Virtual Machine less than 3 CPUs",
                        },
                        {
                            price_per_unit: 0.00956,
                            num_cpus_from: 3,
                            description: "Virtual Machine 3+ CPUs",
                        },
                    ],
                },
                {
                    resource_type: "RAM",
                    resource_prices: [
                        {
                            price_per_unit: 0.00845,
                            gigabytes_from: 0,
                            description: "Virtual Machine GiB RAM",
                        },
                    ],
                },
                {
                    resource_type: "BLOCK_STORAGE",
                    resource_prices: [
                        {
                            price_per_unit: 0.0002,
                            gigabytes_from: 1,
                            description: "Virtual Machine disk 1-80 GiB",
                        },
                        {
                            price_per_unit: 0.0005,
                            gigabytes_from: 81,
                            description: "Virtual Machine disk 81+ GiB",
                        },
                    ],
                },
                {
                    resource_type: "BLOCK_STORAGE_BACKUP",
                    resource_prices: [
                        {
                            gigabytes_from: 1,
                            price_per_unit: 0.0002,
                            description: "Backup of disk 1-80 GiB",
                        },
                        {
                            gigabytes_from: 81,
                            price_per_unit: 0.0003,
                            description: "Backup of disk 81+ GiB",
                        },
                    ],
                },
                {
                    resource_type: "BLOCK_STORAGE_SNAPSHOT",
                    resource_prices: [
                        {
                            gigabytes_from: 1,
                            price_per_unit: 0.0002,
                            description: "Snapshot of disk 1-80 GiB",
                        },
                        {
                            gigabytes_from: 81,
                            price_per_unit: 0.0003,
                            description: "Snapshot of disk 81+ GiB",
                        },
                    ],
                },
                {
                    resource_type: "WINDOWS_LICENSE",
                    resource_prices: [
                        {
                            price_per_unit: 0,
                            description: "Windows license (per CPU)",
                        },
                    ],
                },
                {
                    resource_type: "OBJECT_STORAGE",
                    resource_prices: [
                        {
                            price_per_unit: 0.00814,
                            description: "Object storage",
                        },
                    ],
                },
                {
                    resource_type: "UNASSIGNED_FLOATING_IP",
                    resource_prices: [
                        {
                            price_per_unit: 0.00234,
                            description: "Unassigned floating IP",
                        },
                    ],
                },
                {
                    resource_type: "ASSIGNED_FLOATING_IP",
                    resource_prices: [],
                },
                {
                    resource_type: "LOAD_BALANCER",
                    resource_prices: [
                        {
                            price_per_unit: 5.003,
                            description: "Load balancer",
                        },
                    ],
                },
            ],
            "host_pool:d2fc6881-9316-46d7-b515-b6cddaeee927": [
                {
                    resource_type: "CPU",
                    resource_prices: [
                        {
                            price_per_unit: 0.00721,
                            num_cpus_from: 0,
                            description: "Virtual Machine less than 3 CPUs",
                        },
                        {
                            price_per_unit: 0.00956,
                            num_cpus_from: 3,
                            description: "Virtual Machine 3+ CPUs",
                        },
                    ],
                },
                {
                    resource_type: "RAM",
                    resource_prices: [
                        {
                            price_per_unit: 0.00845,
                            gigabytes_from: 0,
                            description: "Virtual Machine GiB RAM",
                        },
                    ],
                },
                {
                    resource_type: "BLOCK_STORAGE",
                    resource_prices: [
                        {
                            price_per_unit: 0.004,
                            gigabytes_from: 1,
                            description: "Virtual Machine disk 1-80 GiB",
                        },
                        {
                            price_per_unit: 0.01,
                            gigabytes_from: 81,
                            description: "Virtual Machine disk 81+ GiB",
                        },
                    ],
                },
                {
                    resource_type: "BLOCK_STORAGE_BACKUP",
                    resource_prices: [
                        {
                            gigabytes_from: 1,
                            price_per_unit: 0.004,
                            description: "Backup of disk 1-80 GiB",
                        },
                        {
                            gigabytes_from: 81,
                            price_per_unit: 0.006,
                            description: "Backup of disk 81+ GiB",
                        },
                    ],
                },
                {
                    resource_type: "BLOCK_STORAGE_SNAPSHOT",
                    resource_prices: [
                        {
                            gigabytes_from: 1,
                            price_per_unit: 0.004,
                            description: "Snapshot of disk 1-80 GiB",
                        },
                        {
                            gigabytes_from: 81,
                            price_per_unit: 0.006,
                            description: "Snapshot of disk 81+ GiB",
                        },
                    ],
                },
                {
                    resource_type: "WINDOWS_LICENSE",
                    resource_prices: [
                        {
                            price_per_unit: 0.0003,
                            description: "Windows license (per CPU)",
                        },
                    ],
                },
                {
                    resource_type: "OBJECT_STORAGE",
                    resource_prices: [
                        {
                            price_per_unit: 0.00814,
                            description: "Object storage",
                        },
                    ],
                },
                {
                    resource_type: "UNASSIGNED_FLOATING_IP",
                    resource_prices: [
                        {
                            price_per_unit: 0.00234,
                            description: "Unassigned floating IP",
                        },
                    ],
                },
                {
                    resource_type: "ASSIGNED_FLOATING_IP",
                    resource_prices: [],
                },
                {
                    resource_type: "LOAD_BALANCER",
                    resource_prices: [
                        {
                            price_per_unit: 0.003,
                            description: "Load balancer",
                        },
                    ],
                },
            ],
        },
    },
    "2024-01": {
        EUR: {
            DEFAULT: [
                {
                    resource_type: "CPU",
                    resource_prices: [
                        {
                            price_per_unit: 0.007224,
                            num_cpus_from: 0,
                            description: "Virtual Machine less than 3 CPUs",
                        },
                        {
                            price_per_unit: 0.00956,
                            num_cpus_from: 3,
                            description: "Virtual Machine 3+ CPUs",
                        },
                    ],
                },
                {
                    resource_type: "RAM",
                    resource_prices: [
                        {
                            price_per_unit: 0.00845,
                            gigabytes_from: 0,
                            description: "Virtual Machine GiB RAM",
                        },
                    ],
                },
                {
                    resource_type: "BLOCK_STORAGE",
                    resource_prices: [
                        {
                            price_per_unit: 0.000234,
                            gigabytes_from: 1,
                            description: "Virtual Machine disk 1-80 GiB",
                        },
                        {
                            price_per_unit: 0.00065,
                            gigabytes_from: 81,
                            description: "Virtual Machine disk 81+ GiB",
                        },
                    ],
                },
                {
                    resource_type: "BLOCK_STORAGE_BACKUP",
                    resource_prices: [
                        {
                            gigabytes_from: 1,
                            price_per_unit: 0.0002,
                            description: "Backup of disk 1-80 GiB",
                        },
                        {
                            gigabytes_from: 81,
                            price_per_unit: 0.0003,
                            description: "Backup of disk 81+ GiB",
                        },
                    ],
                },
                {
                    resource_type: "BLOCK_STORAGE_SNAPSHOT",
                    resource_prices: [
                        {
                            gigabytes_from: 1,
                            price_per_unit: 0.0002,
                            description: "Snapshot of disk 1-80 GiB",
                        },
                        {
                            gigabytes_from: 81,
                            price_per_unit: 0.0003,
                            description: "Snapshot of disk 81+ GiB",
                        },
                    ],
                },
                {
                    resource_type: "WINDOWS_LICENSE",
                    resource_prices: [
                        {
                            price_per_unit: 0.00748,
                            description: "Windows license (per CPU)",
                        },
                    ],
                },
                {
                    resource_type: "OBJECT_STORAGE",
                    resource_prices: [
                        {
                            price_per_unit: 0.00814,
                            description: "Object storage",
                        },
                    ],
                },
                {
                    resource_type: "UNASSIGNED_FLOATING_IP",
                    resource_prices: [
                        {
                            price_per_unit: 0.00111,
                            description: "Unassigned floating IP",
                        },
                    ],
                },
                {
                    resource_type: "ASSIGNED_FLOATING_IP",
                    resource_prices: [],
                },
                {
                    resource_type: "LOAD_BALANCER",
                    resource_prices: [
                        {
                            price_per_unit: 0.003,
                            description: "Load balancer",
                        },
                    ],
                },
            ],
            "host_pool:00000000-0000-0000-0000-000167bb0a39": [
                {
                    resource_type: "CPU",
                    resource_prices: [
                        {
                            price_per_unit: 0.00721,
                            num_cpus_from: 0,
                            description: "Virtual Machine less than 3 CPUs",
                        },
                        {
                            price_per_unit: 0.00956,
                            num_cpus_from: 3,
                            description: "Virtual Machine 3+ CPUs",
                        },
                    ],
                },
                {
                    resource_type: "RAM",
                    resource_prices: [
                        {
                            price_per_unit: 0.00845,
                            gigabytes_from: 0,
                            description: "Virtual Machine GiB RAM",
                        },
                    ],
                },
                {
                    resource_type: "BLOCK_STORAGE",
                    resource_prices: [
                        {
                            price_per_unit: 0.0002,
                            gigabytes_from: 1,
                            description: "Virtual Machine disk 1-80 GiB",
                        },
                        {
                            price_per_unit: 0.0005,
                            gigabytes_from: 81,
                            description: "Virtual Machine disk 81+ GiB",
                        },
                    ],
                },
                {
                    resource_type: "BLOCK_STORAGE_BACKUP",
                    resource_prices: [
                        {
                            gigabytes_from: 1,
                            price_per_unit: 0.0002,
                            description: "Backup of disk 1-80 GiB",
                        },
                        {
                            gigabytes_from: 81,
                            price_per_unit: 0.0003,
                            description: "Backup of disk 81+ GiB",
                        },
                    ],
                },
                {
                    resource_type: "BLOCK_STORAGE_SNAPSHOT",
                    resource_prices: [
                        {
                            gigabytes_from: 1,
                            price_per_unit: 0.0002,
                            description: "Snapshot of disk 1-80 GiB",
                        },
                        {
                            gigabytes_from: 81,
                            price_per_unit: 0.0003,
                            description: "Snapshot of disk 81+ GiB",
                        },
                    ],
                },
                {
                    resource_type: "WINDOWS_LICENSE",
                    resource_prices: [
                        {
                            price_per_unit: 0,
                            description: "Windows license (per CPU)",
                        },
                    ],
                },
            ],
            "host_pool:d2fc6881-9316-46d7-b515-b6cddaeee927": [
                {
                    resource_type: "CPU",
                    resource_prices: [
                        {
                            price_per_unit: 0.00721,
                            num_cpus_from: 0,
                            description: "Virtual Machine less than 3 CPUs",
                        },
                        {
                            price_per_unit: 0.00956,
                            num_cpus_from: 3,
                            description: "Virtual Machine 3+ CPUs",
                        },
                    ],
                },
                {
                    resource_type: "RAM",
                    resource_prices: [
                        {
                            price_per_unit: 0.00845,
                            gigabytes_from: 0,
                            description: "Virtual Machine GiB RAM",
                        },
                    ],
                },
                {
                    resource_type: "BLOCK_STORAGE",
                    resource_prices: [
                        {
                            price_per_unit: 0.004,
                            gigabytes_from: 1,
                            description: "Virtual Machine disk 1-80 GiB",
                        },
                        {
                            price_per_unit: 0.01,
                            gigabytes_from: 81,
                            description: "Virtual Machine disk 81+ GiB",
                        },
                    ],
                },
                {
                    resource_type: "BLOCK_STORAGE_BACKUP",
                    resource_prices: [
                        {
                            gigabytes_from: 1,
                            price_per_unit: 0.004,
                            description: "Backup of disk 1-80 GiB",
                        },
                        {
                            gigabytes_from: 81,
                            price_per_unit: 0.006,
                            description: "Backup of disk 81+ GiB",
                        },
                    ],
                },
                {
                    resource_type: "BLOCK_STORAGE_SNAPSHOT",
                    resource_prices: [
                        {
                            gigabytes_from: 1,
                            price_per_unit: 0.004,
                            description: "Snapshot of disk 1-80 GiB",
                        },
                        {
                            gigabytes_from: 81,
                            price_per_unit: 0.006,
                            description: "Snapshot of disk 81+ GiB",
                        },
                    ],
                },
                {
                    resource_type: "WINDOWS_LICENSE",
                    resource_prices: [
                        {
                            price_per_unit: 0.0003,
                            description: "Windows license (per CPU)",
                        },
                    ],
                },
            ],
        },
    },
    "2024-09": {
        EUR: {
            DEFAULT: [
                {
                    resource_type: "CPU",
                    resource_prices: [
                        {
                            price_per_unit: 0.007224,
                            num_cpus_from: 0,
                            description: "Virtual Machine less than 3 CPUs",
                        },
                        {
                            price_per_unit: 0.00956,
                            num_cpus_from: 3,
                            description: "Virtual Machine 3+ CPUs",
                        },
                    ],
                },
                {
                    resource_type: "RAM",
                    resource_prices: [
                        {
                            price_per_unit: 0.00845,
                            gigabytes_from: 0,
                            description: "Virtual Machine GiB RAM",
                        },
                    ],
                },
                {
                    resource_type: "BLOCK_STORAGE",
                    resource_prices: [
                        {
                            price_per_unit: 0.000234,
                            gigabytes_from: 1,
                            description: "Virtual Machine disk 1-80 GiB",
                        },
                        {
                            price_per_unit: 0.00065,
                            gigabytes_from: 81,
                            description: "Virtual Machine disk 81+ GiB",
                        },
                    ],
                },
                {
                    resource_type: "BLOCK_STORAGE_BACKUP",
                    resource_prices: [
                        {
                            gigabytes_from: 1,
                            price_per_unit: 0.0003424,
                            description: "Backup of disk 1-80 GiB",
                        },
                        {
                            gigabytes_from: 81,
                            price_per_unit: 0.0003,
                            description: "Backup of disk 81+ GiB",
                        },
                    ],
                },
                {
                    resource_type: "BLOCK_STORAGE_SNAPSHOT",
                    resource_prices: [
                        {
                            gigabytes_from: 1,
                            price_per_unit: 0.0002,
                            description: "Snapshot of disk 1-80 GiB",
                        },
                        {
                            gigabytes_from: 81,
                            price_per_unit: 0.0003,
                            description: "Snapshot of disk 81+ GiB",
                        },
                    ],
                },
                {
                    resource_type: "WINDOWS_LICENSE",
                    resource_prices: [
                        {
                            price_per_unit: 0.00748,
                            description: "Windows license (per CPU)",
                        },
                    ],
                },
                {
                    resource_type: "OBJECT_STORAGE",
                    resource_prices: [
                        {
                            price_per_unit: 0.00787,
                            description: "Object storage",
                        },
                    ],
                },
                {
                    resource_type: "UNASSIGNED_FLOATING_IP",
                    resource_prices: [
                        {
                            price_per_unit: 0.00274,
                            description: "Unassigned floating IP",
                        },
                    ],
                },
                {
                    resource_type: "ASSIGNED_FLOATING_IP",
                    resource_prices: [],
                },
                {
                    resource_type: "LOAD_BALANCER",
                    resource_prices: [
                        {
                            price_per_unit: 0.003,
                            description: "Load balancer",
                        },
                    ],
                },
            ],
            "host_pool:00000000-0000-0000-0000-000167bb0a39": [
                {
                    resource_type: "CPU",
                    resource_prices: [
                        {
                            price_per_unit: 0.00721,
                            num_cpus_from: 0,
                            description: "Virtual Machine less than 3 CPUs",
                        },
                        {
                            price_per_unit: 0.00956,
                            num_cpus_from: 3,
                            description: "Virtual Machine 3+ CPUs",
                        },
                    ],
                },
                {
                    resource_type: "RAM",
                    resource_prices: [
                        {
                            price_per_unit: 0.00845,
                            gigabytes_from: 0,
                            description: "Virtual Machine GiB RAM",
                        },
                    ],
                },
                {
                    resource_type: "BLOCK_STORAGE",
                    resource_prices: [
                        {
                            price_per_unit: 0.0002,
                            gigabytes_from: 1,
                            description: "Virtual Machine disk 1-80 GiB",
                        },
                        {
                            price_per_unit: 0.0005,
                            gigabytes_from: 81,
                            description: "Virtual Machine disk 81+ GiB",
                        },
                    ],
                },
                {
                    resource_type: "BLOCK_STORAGE_BACKUP",
                    resource_prices: [
                        {
                            gigabytes_from: 1,
                            price_per_unit: 0.0002,
                            description: "Backup of disk 1-80 GiB",
                        },
                        {
                            gigabytes_from: 81,
                            price_per_unit: 0.0003,
                            description: "Backup of disk 81+ GiB",
                        },
                    ],
                },
                {
                    resource_type: "BLOCK_STORAGE_SNAPSHOT",
                    resource_prices: [
                        {
                            gigabytes_from: 1,
                            price_per_unit: 0.0002,
                            description: "Snapshot of disk 1-80 GiB",
                        },
                        {
                            gigabytes_from: 81,
                            price_per_unit: 0.0003,
                            description: "Snapshot of disk 81+ GiB",
                        },
                    ],
                },
                {
                    resource_type: "WINDOWS_LICENSE",
                    resource_prices: [
                        {
                            price_per_unit: 0,
                            description: "Windows license (per CPU)",
                        },
                    ],
                },
                {
                    resource_type: "OBJECT_STORAGE",
                    resource_prices: [],
                },
                {
                    resource_type: "UNASSIGNED_FLOATING_IP",
                    resource_prices: [],
                },
                {
                    resource_type: "ASSIGNED_FLOATING_IP",
                    resource_prices: [],
                },
                {
                    resource_type: "LOAD_BALANCER",
                    resource_prices: [],
                },
            ],
            "host_pool:d2fc6881-9316-46d7-b515-b6cddaeee927": [
                {
                    resource_type: "CPU",
                    resource_prices: [
                        {
                            price_per_unit: 0.00721,
                            num_cpus_from: 0,
                            description: "Virtual Machine less than 3 CPUs",
                        },
                        {
                            price_per_unit: 0.00956,
                            num_cpus_from: 3,
                            description: "Virtual Machine 3+ CPUs",
                        },
                    ],
                },
                {
                    resource_type: "RAM",
                    resource_prices: [
                        {
                            price_per_unit: 0.00845,
                            gigabytes_from: 0,
                            description: "Virtual Machine GiB RAM",
                        },
                    ],
                },
                {
                    resource_type: "BLOCK_STORAGE",
                    resource_prices: [
                        {
                            price_per_unit: 0.004,
                            gigabytes_from: 1,
                            description: "Virtual Machine disk 1-80 GiB",
                        },
                        {
                            price_per_unit: 0.01,
                            gigabytes_from: 81,
                            description: "Virtual Machine disk 81+ GiB",
                        },
                    ],
                },
                {
                    resource_type: "BLOCK_STORAGE_BACKUP",
                    resource_prices: [
                        {
                            gigabytes_from: 1,
                            price_per_unit: 0.004,
                            description: "Backup of disk 1-80 GiB",
                        },
                        {
                            gigabytes_from: 81,
                            price_per_unit: 0.006,
                            description: "Backup of disk 81+ GiB",
                        },
                    ],
                },
                {
                    resource_type: "BLOCK_STORAGE_SNAPSHOT",
                    resource_prices: [
                        {
                            gigabytes_from: 1,
                            price_per_unit: 0.004,
                            description: "Snapshot of disk 1-80 GiB",
                        },
                        {
                            gigabytes_from: 81,
                            price_per_unit: 0.006,
                            description: "Snapshot of disk 81+ GiB",
                        },
                    ],
                },
                {
                    resource_type: "WINDOWS_LICENSE",
                    resource_prices: [
                        {
                            price_per_unit: 0.0003,
                            description: "Windows license (per CPU)",
                        },
                    ],
                },
                {
                    resource_type: "OBJECT_STORAGE",
                    resource_prices: [],
                },
                {
                    resource_type: "UNASSIGNED_FLOATING_IP",
                    resource_prices: [],
                },
                {
                    resource_type: "ASSIGNED_FLOATING_IP",
                    resource_prices: [],
                },
                {
                    resource_type: "LOAD_BALANCER",
                    resource_prices: [],
                },
            ],
        },
        THB: {
            DEFAULT: [
                {
                    resource_type: "CPU",
                    resource_prices: [
                        {
                            price_per_unit: 0.01,
                            num_cpus_from: 1,
                            description: "Virtual Machine CPUs",
                        },
                    ],
                },
                {
                    resource_type: "RAM",
                    resource_prices: [
                        {
                            price_per_unit: 0.02,
                            gigabytes_from: 0.5,
                            description: "Virtual Machine GiB RAM",
                        },
                    ],
                },
                {
                    resource_type: "BLOCK_STORAGE",
                    resource_prices: [
                        {
                            price_per_unit: 0.03,
                            gigabytes_from: 1,
                            description: "Virtual Machine disk GiB",
                        },
                    ],
                },
                {
                    resource_type: "BLOCK_STORAGE_BACKUP",
                    resource_prices: [
                        {
                            price_per_unit: 0.04,
                            gigabytes_from: 1,
                            description: "Backup of disk GiB",
                        },
                    ],
                },
                {
                    resource_type: "BLOCK_STORAGE_SNAPSHOT",
                    resource_prices: [
                        {
                            price_per_unit: 0.05,
                            gigabytes_from: 1,
                            description: "Snapshot of disk GiB",
                        },
                    ],
                },
                {
                    resource_type: "WINDOWS_LICENSE",
                    resource_prices: [
                        {
                            price_per_unit: 0.06,
                            description: "Windows license (per CPU)",
                        },
                    ],
                },
                {
                    resource_type: "OBJECT_STORAGE",
                    resource_prices: [
                        {
                            price_per_unit: 0.07,
                            description: "Object storage",
                        },
                    ],
                },
                {
                    resource_type: "UNASSIGNED_FLOATING_IP",
                    resource_prices: [
                        {
                            price_per_unit: 0.08,
                            description: "Unassigned floating IP",
                        },
                    ],
                },
                {
                    resource_type: "ASSIGNED_FLOATING_IP",
                    resource_prices: [
                        {
                            price_per_unit: 0.09,
                            description: "Assigned floating IP",
                        },
                    ],
                },
                {
                    resource_type: "LOAD_BALANCER",
                    resource_prices: [
                        {
                            price_per_unit: 0.1,
                            description: "Load balancer",
                        },
                    ],
                },
            ],
        },
    },
    "2025-09": {
        EUR: {
            DEFAULT: [
                {
                    resource_type: "CPU",
                    resource_prices: [
                        {
                            price_per_unit: 0.007224,
                            num_cpus_from: 0,
                            description: "Virtual Machine less than 3 CPUs",
                        },
                        {
                            price_per_unit: 0.00956,
                            num_cpus_from: 3,
                            description: "Virtual Machine 3+ CPUs",
                        },
                    ],
                },
                {
                    resource_type: "RAM",
                    resource_prices: [
                        {
                            price_per_unit: 0.00845,
                            gigabytes_from: 0,
                            description: "Virtual Machine GiB RAM",
                        },
                    ],
                },
                {
                    resource_type: "BLOCK_STORAGE",
                    resource_prices: [
                        {
                            price_per_unit: 0.000234,
                            gigabytes_from: 1,
                            description: "Virtual Machine disk 1-80 GiB",
                        },
                        {
                            price_per_unit: 0.00065,
                            gigabytes_from: 81,
                            description: "Virtual Machine disk 81+ GiB",
                        },
                    ],
                },
                {
                    resource_type: "BLOCK_STORAGE_BACKUP",
                    resource_prices: [
                        {
                            gigabytes_from: 1,
                            price_per_unit: 0.0003424,
                            description: "Backup of disk 1-80 GiB",
                        },
                        {
                            gigabytes_from: 81,
                            price_per_unit: 0.0003,
                            description: "Backup of disk 81+ GiB",
                        },
                    ],
                },
                {
                    resource_type: "BLOCK_STORAGE_SNAPSHOT",
                    resource_prices: [
                        {
                            gigabytes_from: 1,
                            price_per_unit: 0.0002,
                            description: "Snapshot of disk 1-80 GiB",
                        },
                        {
                            gigabytes_from: 81,
                            price_per_unit: 0.0003,
                            description: "Snapshot of disk 81+ GiB",
                        },
                    ],
                },
                {
                    resource_type: "WINDOWS_LICENSE",
                    resource_prices: [
                        {
                            price_per_unit: 0.00748,
                            description: "Windows license (per CPU)",
                        },
                    ],
                },
                {
                    resource_type: "OBJECT_STORAGE",
                    resource_prices: [
                        {
                            price_per_unit: 0.00787,
                            description: "Object storage",
                        },
                    ],
                },
                {
                    resource_type: "UNASSIGNED_FLOATING_IP",
                    resource_prices: [
                        {
                            price_per_unit: 0.00274,
                            description: "Unassigned floating IP",
                        },
                    ],
                },
                {
                    resource_type: "ASSIGNED_FLOATING_IP",
                    resource_prices: [],
                },
                {
                    resource_type: "LOAD_BALANCER",
                    resource_prices: [
                        {
                            price_per_unit: 0.003,
                            description: "Load balancer",
                        },
                    ],
                },
            ],
            "host_pool:00000000-0000-0000-0000-000167bb0a39": [
                {
                    resource_type: "CPU",
                    resource_prices: [
                        {
                            price_per_unit: 0.00721,
                            num_cpus_from: 0,
                            description: "Virtual Machine less than 3 CPUs",
                        },
                        {
                            price_per_unit: 0.00956,
                            num_cpus_from: 3,
                            description: "Virtual Machine 3+ CPUs",
                        },
                    ],
                },
                {
                    resource_type: "RAM",
                    resource_prices: [
                        {
                            price_per_unit: 0.00845,
                            gigabytes_from: 0,
                            description: "Virtual Machine GiB RAM",
                        },
                    ],
                },
                {
                    resource_type: "BLOCK_STORAGE",
                    resource_prices: [
                        {
                            price_per_unit: 0.0002,
                            gigabytes_from: 1,
                            description: "Virtual Machine disk 1-80 GiB",
                        },
                        {
                            price_per_unit: 0.0005,
                            gigabytes_from: 81,
                            description: "Virtual Machine disk 81+ GiB",
                        },
                    ],
                },
                {
                    resource_type: "BLOCK_STORAGE_BACKUP",
                    resource_prices: [
                        {
                            gigabytes_from: 1,
                            price_per_unit: 0.0002,
                            description: "Backup of disk 1-80 GiB",
                        },
                        {
                            gigabytes_from: 81,
                            price_per_unit: 0.0003,
                            description: "Backup of disk 81+ GiB",
                        },
                    ],
                },
                {
                    resource_type: "BLOCK_STORAGE_SNAPSHOT",
                    resource_prices: [
                        {
                            gigabytes_from: 1,
                            price_per_unit: 0.0002,
                            description: "Snapshot of disk 1-80 GiB",
                        },
                        {
                            gigabytes_from: 81,
                            price_per_unit: 0.0003,
                            description: "Snapshot of disk 81+ GiB",
                        },
                    ],
                },
                {
                    resource_type: "WINDOWS_LICENSE",
                    resource_prices: [
                        {
                            price_per_unit: 0,
                            description: "Windows license (per CPU)",
                        },
                    ],
                },
                {
                    resource_type: "OBJECT_STORAGE",
                    resource_prices: [],
                },
                {
                    resource_type: "UNASSIGNED_FLOATING_IP",
                    resource_prices: [],
                },
                {
                    resource_type: "ASSIGNED_FLOATING_IP",
                    resource_prices: [],
                },
                {
                    resource_type: "LOAD_BALANCER",
                    resource_prices: [],
                },
            ],
            "host_pool:d2fc6881-9316-46d7-b515-b6cddaeee927": [
                {
                    resource_type: "CPU",
                    resource_prices: [
                        {
                            price_per_unit: 0.00721,
                            num_cpus_from: 0,
                            description: "Virtual Machine less than 3 CPUs",
                        },
                        {
                            price_per_unit: 0.00956,
                            num_cpus_from: 3,
                            description: "Virtual Machine 3+ CPUs",
                        },
                    ],
                },
                {
                    resource_type: "RAM",
                    resource_prices: [
                        {
                            price_per_unit: 0.00845,
                            gigabytes_from: 0,
                            description: "Virtual Machine GiB RAM",
                        },
                    ],
                },
                {
                    resource_type: "BLOCK_STORAGE",
                    resource_prices: [
                        {
                            price_per_unit: 0.004,
                            gigabytes_from: 1,
                            description: "Virtual Machine disk 1-80 GiB",
                        },
                        {
                            price_per_unit: 0.01,
                            gigabytes_from: 81,
                            description: "Virtual Machine disk 81+ GiB",
                        },
                    ],
                },
                {
                    resource_type: "BLOCK_STORAGE_BACKUP",
                    resource_prices: [
                        {
                            gigabytes_from: 1,
                            price_per_unit: 0.004,
                            description: "Backup of disk 1-80 GiB",
                        },
                        {
                            gigabytes_from: 81,
                            price_per_unit: 0.006,
                            description: "Backup of disk 81+ GiB",
                        },
                    ],
                },
                {
                    resource_type: "BLOCK_STORAGE_SNAPSHOT",
                    resource_prices: [
                        {
                            gigabytes_from: 1,
                            price_per_unit: 0.004,
                            description: "Snapshot of disk 1-80 GiB",
                        },
                        {
                            gigabytes_from: 81,
                            price_per_unit: 0.006,
                            description: "Snapshot of disk 81+ GiB",
                        },
                    ],
                },
                {
                    resource_type: "WINDOWS_LICENSE",
                    resource_prices: [
                        {
                            price_per_unit: 0.0003,
                            description: "Windows license (per CPU)",
                        },
                    ],
                },
                {
                    resource_type: "OBJECT_STORAGE",
                    resource_prices: [],
                },
                {
                    resource_type: "UNASSIGNED_FLOATING_IP",
                    resource_prices: [],
                },
                {
                    resource_type: "ASSIGNED_FLOATING_IP",
                    resource_prices: [],
                },
                {
                    resource_type: "LOAD_BALANCER",
                    resource_prices: [],
                },
            ],
            "metal_spec_uuid:00000000-0000-0000-0001-000000000001": [
                {
                    resource_type: "BARE_METAL_SERVER",
                    resource_prices: [
                        {
                            price_per_unit: 0.889041096,
                            description: "Bare Metal Server",
                        },
                    ],
                },
            ],
        },
    },
    "2030-10": {
        EUR: {
            DEFAULT: [
                {
                    resource_type: "CPU",
                    resource_prices: [
                        {
                            price_per_unit: 0.009224,
                            num_cpus_from: 0,
                            description: "Virtual Machine CPUs",
                        },
                    ],
                },
                {
                    resource_type: "RAM",
                    resource_prices: [
                        {
                            price_per_unit: 0.01245,
                            gigabytes_from: 0,
                            description: "Virtual Machine GiB RAM",
                        },
                    ],
                },
                {
                    resource_type: "BLOCK_STORAGE",
                    resource_prices: [
                        {
                            price_per_unit: 0.002234,
                            gigabytes_from: 1,
                            description: "Virtual Machine disk GiB",
                        },
                    ],
                },
                {
                    resource_type: "BLOCK_STORAGE_BACKUP",
                    resource_prices: [
                        {
                            price_per_unit: 0.0033424,
                            gigabytes_from: 1,
                            description: "Backup of disk GiB",
                        },
                    ],
                },
                {
                    resource_type: "BLOCK_STORAGE_SNAPSHOT",
                    resource_prices: [
                        {
                            price_per_unit: 0.0022,
                            gigabytes_from: 1,
                            description: "Snapshot of disk GiB",
                        },
                    ],
                },
                {
                    resource_type: "WINDOWS_LICENSE",
                    resource_prices: [],
                },
                {
                    resource_type: "OBJECT_STORAGE",
                    resource_prices: [],
                },
                {
                    resource_type: "UNASSIGNED_FLOATING_IP",
                    resource_prices: [],
                },
                {
                    resource_type: "ASSIGNED_FLOATING_IP",
                    resource_prices: [],
                },
                {
                    resource_type: "LOAD_BALANCER",
                    resource_prices: [],
                },
            ],
        },
    },
};
